import React, { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'

import { DATE_SHORT_FORMAT } from '../../../../../App/DateFormats'
import { IRepeatDetails } from '../../../../types'

import { RepeatsMessage } from './style'

export interface IProps {
  repeatDetails: IRepeatDetails | null
}

export const UpdateRepeatMessage: FunctionComponent<IProps> = ({
  repeatDetails,
}) => {
  const { t } = useTranslation()

  if (!repeatDetails) {
    return null
  }

  const { weekInterval, startsAt, stopsAt } = repeatDetails
  return (
    <RepeatsMessage>
      {t(`This appointment repeats from 
            ${startsAt.format(DATE_SHORT_FORMAT)} every 
            ${weekInterval} until of 
            ${stopsAt.format(DATE_SHORT_FORMAT)}`)}
    </RepeatsMessage>
  )
}
